import beach00 from '../images/beach00.png';
import beach01 from '../images/beach01.png';
import beach02 from '../images/beach02.png';
import city00 from '../images/city00.png';
import lake00 from '../images/lake00.png';

const backgrounds = [beach00, beach01, beach02, city00, lake00];

export default backgrounds;
